import styled from '@emotion/styled'
import VivaldisLogoTypeAsset from './assets/vivaldis-logotype.svg'
import { AppLogoProps } from './typings/AppLogoProps'

export const AppLogo = ({ width = 104 }: AppLogoProps) => {
  return <Image src={VivaldisLogoTypeAsset} width={width} />
}

const Image = styled('img')<{ width: number }>`
  width: ${({ width }) => `${width}px`};
  height: ${({ width }) => `${Math.round(width / 2.6)}px`};
`
